/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * yesterday object
 * @export
 * @interface GetFwLeaderboardsCharactersYesterdayYesterday
 */
export interface GetFwLeaderboardsCharactersYesterdayYesterday {
    /**
     * Amount of kills
     * @type {number}
     * @memberof GetFwLeaderboardsCharactersYesterdayYesterday
     */
    amount?: number;
    /**
     * character_id integer
     * @type {number}
     * @memberof GetFwLeaderboardsCharactersYesterdayYesterday
     */
    characterId?: number;
}

/**
 * Check if a given object implements the GetFwLeaderboardsCharactersYesterdayYesterday interface.
 */
export function instanceOfGetFwLeaderboardsCharactersYesterdayYesterday(value: object): value is GetFwLeaderboardsCharactersYesterdayYesterday {
    return true;
}

export function GetFwLeaderboardsCharactersYesterdayYesterdayFromJSON(json: any): GetFwLeaderboardsCharactersYesterdayYesterday {
    return GetFwLeaderboardsCharactersYesterdayYesterdayFromJSONTyped(json, false);
}

export function GetFwLeaderboardsCharactersYesterdayYesterdayFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwLeaderboardsCharactersYesterdayYesterday {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'characterId': json['character_id'] == null ? undefined : json['character_id'],
    };
}

export function GetFwLeaderboardsCharactersYesterdayYesterdayToJSON(json: any): GetFwLeaderboardsCharactersYesterdayYesterday {
    return GetFwLeaderboardsCharactersYesterdayYesterdayToJSONTyped(json, false);
}

export function GetFwLeaderboardsCharactersYesterdayYesterdayToJSONTyped(value?: GetFwLeaderboardsCharactersYesterdayYesterday | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'character_id': value['characterId'],
    };
}

